<div class="cm__container is-fullwidth">
  <div class="cm__container__col">
    <div class="single-brand">
      <h1 class="cm_secure_file_heading">Secure File Upload</h1>
      <div class="cm_secure_file_text">
        <br />
        Securely upload any new business or service PDF file (less than 100MB) you need to send to us.
        <span *ngIf="errormessage !== 'You have not specified a file.'">
          You'll receive email confirmation after each file is uploaded.</span
        >
        <i> Please follow your broker/dealer procedures for document upload.</i><br /><br />
      </div>

      <form
        action=""
        id="form1"
        method="post"
        name="form1"
        novalidate="novalidate"
        enctype="multipart/form-data"
        data-gtm-form-interact-id="0"
      >
        <input name="__RequestVerificationToken" type="hidden" value="" />
        <div class="cm__secure-upload-form js-cm__secure-upload-form">
          <span class="cm__secure-upload-form__file">
            <label
              for="file-upload"
              id="fileLbl"
              class="button"
              role="button"
              aria-label="Browse for a file to upload"
              tabindex="0"
              (keydown.enter)="fileInput.click()"
            >
              {{ filelbl }}</label
            >
            <input
              type="file"
              name="file"
              #fileInput
              id="file-upload"
              onclick="this.value = null"
              (change)="OnFileChange($event)"
              [disabled]="isUploading"
              data-gtm-form-interact-field-id="0"
              aria-describedby="errormsg"
            />
            <span class="cm__secure-upload-form__filename"> </span>
          </span>
          <span class="cm__secure-upload-form__buttons">
            <button
              [disabled]="isUploading"
              id="btnSubmit"
              (click)="secureFileUpload()"
              class="cm__button cm__button--small cm__button--tertiary upload-btn"
              type="button"
            >
              {{ btnName }}
            </button>
          </span>
          <span *ngIf="isUploading">
            <div id="loading"></div>
          </span>
          <br /><br /><br />
          <span #errormsg id="errormsg" aria-live="polite" role="alert" tabindex="0">{{ errormessage }}</span>
        </div>
      </form>
    </div>
  </div>
</div>
